import { CompassCardUI } from '@scale/compass-ui/types';
import {
  SaveToSnowflakeContext,
  SaveToSnowflakeWriteMode,
  SaveToSnowflakeCardShared,
  SAVE_TO_SNOWFLAKE,
  SaveToSnowflakeSchemaType,
} from '@scale/genai-compass-shared/cards/save_to_snowflake';
import { faSnowflake } from '@fortawesome/pro-solid-svg-icons';
import SaveToSnowflakeCardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/SaveToSnowflakeCard/SaveToSnowflakeCardComponent';

const defaultContext: SaveToSnowflakeContext = {
  cardType: SAVE_TO_SNOWFLAKE,
  writeMode: SaveToSnowflakeWriteMode.APPEND,
};

export const SaveToSnowflakeCardInfo: CompassCardUI<SaveToSnowflakeSchemaType> = {
  ...SaveToSnowflakeCardShared,
  title: 'Save to Snowflake',
  icon: 'download',
  toolTip: 'Save previous output to Snowflake table.',
  defaultContext,
  isAdvanced: true,
  button: {
    icon: faSnowflake,
  },
  legacyComponent: SaveToSnowflakeCardComponent,
};
